
const stopPropagation = (e) => {
  e.stopPropagation()
}

const ShortlistTrend = ({ trend, toggleCheckbox }) => {

  return <div onClick={stopPropagation}>
    <label className="flex items-center cursor-pointer">

      <span className="ml-2 mr-1 text-gray-800 ">Shortlist</span>
      <div
        className={`w-6 h-6 border-2 rounded flex items-center justify-center transition-all duration-200
          ${trend.shortlisted ? 'bg-blue-500 border-blue-500' : 'bg-white border-gray-400'}`}

      >
        {trend.shortlisted && (
          <svg
            className="w-4 h-4 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
          </svg>
        )}
      </div>
      <input
        type="checkbox"
        id={'shortlist-toggle-' + trend._id}
        className="sr-only" // Visually hide the native input
        checked={trend.shortlisted}
        onChange={toggleCheckbox}
      />
    </label>
  </div>
}

export default ShortlistTrend
